import '../../admin-shared.css'

import { useNavigate, useParams } from 'react-router-dom'

import { Input, PageHeader, Spinner } from '../../../../Components'
import { useCQuery } from '../../../../Services'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { AdminEditorActions } from '../../Components/AdminTableActions'
import { saveUser, useUser } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language]

const textFields = {
  username: { label: t.admUsername },
  password: { label: t.admPassword }
}

const roleOptions = [
  { value: 'admin', label: 'Admin' },
  { value: 'operator', label: 'Operatore' },
  { value: 'dynamicTester', label: 'Dynamic Tester' },
  { value: 'tester', label: 'Tester' },
  { value: 'operatorCommunity', label: 'Operatore Community' },
  { value: 'fatturazione', label: 'Fatturazione' },
  { value: 'apiuser', label: 'API User' },
  { value: 'appUser', label: 'App User' }
]

export function UserEditor() {
  const { userId } = useParams()
  const navigate = useNavigate()
  const [user, setUser, isSuccess] = useUser(userId)
  const { id = '' } = user || {}
  const { data: environments = [] } = useCQuery(['environments'])

  const environmentOptions = environments.map(({ id: envId, societyName, codSociety }) => ({
    value: envId,
    label: `${societyName} (${codSociety})`
  }))

  const save = async () => {
    const res = await saveUser(user)
    res?.id && navigate('/admin/users/list')
    return res
  }

  if (!isSuccess || !user) return <Spinner />

  const isNew = id === 'new'

  return (
    <div className="admin-page--medium">
      <PageHeader
        title={isNew ? t.admCreaUtente : t.admModificaUtente}
        actions={
          <AdminEditorActions
            onBack={() => navigate('/admin/users/list')}
            onSave={save}
            backLabel={t.tornaIndietro}
            saveLabel={t.salva}
          />
        }
      />

      <div className="nsec">
        <div className="nsec__head">
          <div className="nsec__ico">
            <i className="pi pi-user" style={{ fontSize: 16 }} />
          </div>
          <h3 className="nsec__title">{t.admAnagraficaUtente}</h3>
        </div>
        <div className="nsec__body">
          <div className="nrow">
            {Object.keys(textFields).map((key) => (
              <div key={key} className="nfield" style={{ gridColumn: 'span 4' }}>
                <label>{textFields[key]?.label}</label>
                <Input
                  value={user[key]}
                  onChange={({ [key]: value }) => setUser(key, value)}
                  id={key}
                  style={{ width: '100%' }}
                />
              </div>
            ))}
            <div className="nfield" style={{ gridColumn: 'span 4' }}>
              <label>{t.admRuolo}</label>
              <Input
                value={user.role}
                dropdown
                options={roleOptions}
                onChange={({ role: value }) => setUser('role', value)}
                id="role"
                placeholder="Seleziona un ruolo"
                style={{ width: '100%' }}
              />
            </div>
            <div className="nfield" style={{ gridColumn: 'span 4' }}>
              <label>{t.admIdEnvironment}</label>
              <Input
                value={user.environmentId}
                dropdown
                options={environmentOptions}
                onChange={({ environmentId: value }) => setUser('environmentId', value)}
                id="environmentId"
                placeholder="Seleziona un environment"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
